export const components = {
  emptyState: {
    primaryTitle: 'Jejda!',
    primaryText: 'Zatím tu nic není…',
    secondaryTitle: 'Nic k zobrazení',
    secondaryText: 'Bohužel, nejsou žádné položky k zobrazení podle použitých filtrů…'
  },
  filters: {
    all: 'Vše',
    search: 'Hledat',
    priceRange: 'Rozsah cen {currency}',
    minValue: 'Minimální hodnota je {val}!',
    maxValue: 'Maximální hodnota je {val}!',
    reset: 'Resetovat',
    apply: 'Použít'
  },
  comments: {
    reply: 'Odpověď',
    loadMore: 'Načíst více',
    edited: 'Upraveno',
    noComments: 'Zatím zde nejsou žádné komentáře',
    leaveFirstComment: 'Můžete zanechat první'
  },
  curtain: {
    close: 'Zavřít'
  },
  photoPreview: {
    close: 'Zavřít'
  },
  photoCropper: {
    back: 'Zpět',
    save: 'Uložit'
  },
  rightSidebar: {
    in: 'v'
  },
  pushPrompt: {
    title: '“{appName}” by chtěl/a zasílat oznámení',
    description: 'Oznámení mohou obsahovat upozornění, zvuky a ikony. Tyto lze konfigurovat v nastavení.',
    later: 'Zeptat se později',
    neverLater: 'Už nikdy se neptejte',
    allow: 'Povolit'
  },
  inAppPush: {
    attachment: 'Příloha'
  },
  installPrompt: {
    android: {
      install: 'Instalovat',
      description: 'Pro plynulý zážitek nemusíte používat prohlížeč. Stačí ho nainstalovat jako aplikaci.',
      press: 'Stiskněte',
      andSelect: 'a vyberte',
      orSimply: 'nebo jednoduše',
      description2: 'klikněte na tlačítko Instalovat níže',
      notNow: 'Nyní ne'
    },
    ios: {
      justTap: 'Klepněte na',
      buttonInBrowser: 'tlačítko „Více" ve vašem prohlížeči a vyberte „Sdílet"',
      addToHomeScreen: 'Přejeďte dolů a klepněte na „Přidat na plochu", poté klikněte na „Přidat"',
      appWillBeInstalled: 'Aplikace bude přidána na vaši domovskou obrazovku'
    },
    installApp: 'Nainstalujte aplikaci',
    useWeb: 'Použít webovou verzi'
  },
  footer: {
    more: 'Menu'
  },
  menu: {
    installApp: 'Nainstalovat aplikaci',
    menu: 'Menu',
    close: 'Zavřít'
  },
  404: {
    whoops: 'Jejda!',
    description: 'Zdá se, že stránka neexistuje, nebo možná k ní nemáte přístup. Pro více informací kontaktujte vlastníka aplikace.',
    ok: 'OK'
  },
  relatedUsers: {
    seeall: 'Zobrazit vše'
  },
  networkingCurtain: {
    'newOneOnOne': 'Nové 1:1',
    'details': 'Detaily',
    'coverMessage': 'Úvodní zpráva',
    'location': 'Místo',
    'duration': 'Doba trvání',
    '15min': '15 min',
    '30min': '30 min',
    '45min': '45 min',
    '60min': '60 min',
    'timeSlot': 'Časový úsek',
    'sendInvitation': 'Odeslat pozvánku',
    'success': 'Úspěch',
    'invitationSent':
      'Úspěšně jste odeslali pozvánku na 1:1 schůzku. Chcete zůstat na této stránce, nebo přejít na všechny naplánované 1:1?',
    'seeAll': 'Zobrazit všechny 1:1 schůzky',
    'stayHere': 'Zůstat zde'
  },
  networking: {
    level: {
      1: 'Ještě není připraven na networking. Žádná významná aktivita nebo zapojení.',
      2: 'Zřídka aktivní nebo chybí klíčové informace v profilu, což ztěžuje propojení s ostatními.',
      3: 'Profil je kompletní s fotografií a online, plně připraven na networking.',
      4: 'Budování momenta - iniciováno alespoň jedno spojení v posledních 6 hodinách.',
      5: 'Mistr networkingu - aktivně reaguje na žádosti a zapojuje se s ostatními v posledních 6 hodinách.'
    }
  },
  time: {
    days: 'd',
    hours: 'h',
    minutes: 'm',
    seconds: 's',
    startsIn: 'za',
    Today: 'Dnes',
    today: 'dnes',
    Tomorrow: 'Zítra',
    tomorrow: 'zítra',
    Yesterday: 'Včera',
    yesterday: 'včera',
    startingNow: 'začíná nyní'
  },
  daysMonths: {
    months: "['Leden','Únor','Březen','Duben','Květen','Červen','Červenec','Srpen','Září','Říjen','Listopad','Prosinec']",
    monthsShort: "['Led', 'Úno', 'Bře', 'Dub', 'Kvě', 'Čer', 'Čvc', 'Srp', 'Zář', 'Říj', 'Lis', 'Pro']",
    weekdays: "['Neděle', 'Pondělí', 'Úterý', 'Středa', 'Čtvrtek', 'Pátek', 'Sobota']",
    weekdaysShort: "['Ne', 'Po', 'Út', 'St', 'Čt', 'Pá', 'So']",
    weekdaysMin: "['Ne', 'Po', 'Út', 'St', 'Čt', 'Pá', 'So']"
  },
  badges: {
    legend: 'Legendary Networker',
    push: 'Online and Trusted',
    leader: 'Leaderboard Champ',
    meetmaster: '1:1 Meeting Master',
    connector: '3-Time Connector',
    legend_description: 'Dosáhněte úrovně Legend alespoň jednou aktivním síťováním a navazováním smysluplných spojení.',
    push_description: 'Povolit push notifikace, abyste zůstali pohotoví a nikdy nepropásli příležitost.',
    leader_description: 'Dostaňte se alespoň jednou do top 10 % na žebříčku.',
    meetmaster_description: 'Začněte nebo reagujte na alespoň jednu žádost o 1:1 schůzku v aplikaci.',
    connector_description: 'Navázat alespoň tři spojení prostřednictvím aplikace během komponent.'
  }
}
